export default __webpack_public_path__ + "static/media/location_preview_skate_park.a6da2959.svg";